<div  *ngIf="tVersion === '1'" style="display: flex; flex-direction: column; margin-left: 1px; margin-right: 1px;" data-cy="input-version1-container-div">

  <ng-container *ngIf="placeholderPosition === 'above'"  >
    <div style="flex-basis: 20px; " data-cy="input-version1-placeholder-above-div">{{placeholder}}</div>
  </ng-container>
  <mat-form-field disabled="true" style="width:100%; margin-top: 0; flex: 1;" [style.width.px]="width" [class]="class" [style]="style" data-cy="input-version1-form-field">
    <mat-label *ngIf="placeholderPosition === 'inline'" data-cy="input-version1-form-field-inline-label">{{placeholder}}</mat-label>
    <input (appInputFinished)="onInputFinished($event)" [disabled]="disabled" matInput [(ngModel)]="value" [maxlength]="maxCharacters === 0? null: maxCharacters" data-cy="input-version1-form-field-input"/>

  </mat-form-field>



</div>

<div *ngIf="tVersion === 'DX'" style="display: flex; flex-direction: column; margin-left: 1px; margin-right: 1px;" data-cy="input-versionDX-container-div">
<dx-text-box  style="background-color: white; border-bottom-width: 1px; border-bottom-color: #00a8ff;"

              [(value)]="value"
              [placeholder] = "placeholder"
              [readOnly]="disabled"
              [label]="placeholder"
              (appInputFinished)="onInputFinished($event)"
              [maxLength]="maxCharacters === 0? null: maxCharacters"
              data-cy="input-versionDX-text-box"
>
</dx-text-box>
</div>
